var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bs-row',{staticClass:"profile-block",attrs:{"h100":"","align-items-center":""}},[_c('bs-col',{attrs:{"col-auto":""}},[_c('div',{staticClass:"avatar"})]),_vm._v(" "),_c('bs-col',[_c('div',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm._f("locale")("logout")))])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3e053b8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/views/layouts/header/uc-profile-block.vue
// module id = 750
// module chunks = 0